import { Injectable } from '@angular/core';
import { LgvAdminOrLendingPadGuard } from '../guards/lgv-admin-or-lending-pad.guard';
import { LgvUserService } from './lgv-user.service';
import { first, skipWhile } from 'rxjs';
import { LgvCompanyService } from './lgv-company.service';
@Injectable({
    providedIn: 'root'
})
export class LgvNavItem {
    label: string;
    link: string;
    roles: string[] = [];
    hidden?: boolean;
    icon?: string;
    iconStyle?: string;
    isPreLicensed?: boolean;
}

export class LgvModuleItem extends LgvNavItem {
    childPages: LgvNavItem[] = [];
    id: string;

    get childPageWithFullPath(): LgvNavItem[] {
        let rtnArray = [];
        this.childPages.forEach(x => {
            rtnArray.push({
                label: x.label,
                link: this.link + '/' + x.link,
                roles: x.roles,
                hidden: x.hidden
            });
        });
        return rtnArray;
    }

    static NavItemFromLink(mod: LgvModuleItem, link: string): LgvNavItem {
        link = LgvModuleService.StripUrlBeforeHash(link);

        let urlParts = link.split('/');

        if (mod && mod.childPages.length == 0) {
            return mod;
        } else if (urlParts.length > 2) {
            let searchLink = urlParts[2];

            let newNav = mod?.childPages?.find(x => x.link == searchLink);
            if (newNav) {
                return newNav;
            }
        } else if (mod.childPages && mod.childPages.length > 1) {
            return mod.childPages[0];
        }

        console.log(
            '*** NavItem NOT FOUND *** - ' + link + ' | ' + urlParts[2]
        );
        console.log(urlParts);
        //console.log(mod.childPages);
        return null;
    }

    get Navigation(): LgvNavItem[] {
        return this.childPages.filter(x => !x.hidden);
    }
    get NavigationWithFullPath(): LgvNavItem[] {
        return this.childPageWithFullPath.filter(x => !x.hidden);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LgvModuleService {
    ClientModule: LgvModuleItem;
    AgentModule: LgvModuleItem;
    DefaultModule: LgvModuleItem;
    AdminModule: LgvModuleItem;
    TokenModule: LgvModuleItem;
    Modules: LgvModuleItem[] = [];

    MasterPageList: LgvNavItem[] = [];

    constructor(
        private companyService: LgvCompanyService,
        private userService: LgvUserService
    ) {
        this.Init();
    }

    Init() {
        let x = new LgvModuleItem();
        x.id = 'default';
        x.label = 'Default';
        x.link = 'default';
        x.roles = [''];
        x.childPages = [
            { label: 'Home', link: 'home', roles: [''] },
            {
                label: 'Client Registration',
                link: 'client-registration',
                roles: ['']
            },
            {
                label: 'Client Registration',
                link: 'external-client-registration',
                roles: ['']
            },
            { label: 'Log in', link: 'login', roles: [''] },
            {
                label: 'Not Verified',
                link: 'not-verified',
                roles: [''],
                hidden: true
            }
        ];
        this.DefaultModule = x;

        x = new LgvModuleItem();
        x.id = 'clientView';
        x.label = 'Client View';
        x.link = 'client';
        x.roles = [''];
        x.childPages = [];
        this.ClientModule = x;

        x = new LgvModuleItem();
        x.id = 'agentView';
        x.label = 'Agent View';
        x.link = 'agent';
        x.roles = [''];
        x.childPages = [
            {
                label: 'Loan Pipeline',
                link: 'loan-pipeline',
                roles: ['Agent', 'DualLicensedAgent']
            },
            { label: 'Activities', link: 'activities', roles: [''] },
            { label: 'Clients', link: 'clients', roles: [''] },
            { label: 'Profile', link: 'profile', roles: [''] },
            {
                label: 'Onboarding Checklist',
                link: 'onboarding-checklist',
                roles: ['']
            },
            {
                label: 'Client Details',
                link: 'client-details',
                roles: [''],
                hidden: true
            }
        ];
        this.AgentModule = x;

        x = new LgvModuleItem();
        x.id = 'adminView';
        x.label = 'Admin View';
        x.link = 'admin';
        x.roles = ['Admin'];
        x.childPages = [
            {
                label: 'Licensing',
                link: 'licensing',
                roles: ['Admin'],
                isPreLicensed: true
            },
            { link: 'loan-pipeline', label: 'Loan Pipeline', roles: ['Admin'] },
            { link: 'short-app', label: 'Pre-qualification Form', roles: [] },
            { link: 'admin-activities', label: 'Activities', roles: ['Admin'] },
            {
                link: 'agents',
                label: 'Agents',
                roles: ['Admin', 'ConciergeKey']
            },
            { link: 'auth-info', label: 'Auth Info', roles: ['Admin'] },
            {
                link: 'service-tester',
                label: 'Service Tester',
                roles: ['Admin']
            },
            //{ link: 'widget-configuration', label: 'Widget Configuration', roles: ['Admin'] },
            //{ link: 'admin-profile', label: 'Agent Profile', roles: ['Admin'], hidden: true },
            {
                link: 'agent-activities',
                label: 'Agent Activities',
                roles: ['Admin'],
                hidden: true
            },
            {
                link: 'agent-clients',
                label: 'Agent Clients',
                roles: ['Admin'],
                hidden: true
            },
            {
                label: 'Client Details',
                link: 'client-details',
                roles: [''],
                hidden: true
            },
            { link: 'agent', label: 'Agent', roles: [''], hidden: true },
            { link: 'view-agent', label: 'Agent', roles: [''], hidden: true },
            { link: 'test', label: 'Test', roles: ['Admin'], hidden: true },
            { link: 'xxx', label: 'XXX', roles: ['Admin'], hidden: true },
            {
                label: 'Add client',
                link: 'create-client',
                roles: ['Admin'],
                hidden: true
            },
            {
                label: 'Client Details',
                link: 'client-details',
                roles: [''],
                hidden: true
            },
            { label: 'Company', link: 'company', roles: [''], hidden: true },
            {
                label: 'Onboarding Checklist',
                link: 'onboarding-checklist',
                roles: ['']
            }
        ];
        this.AdminModule = x;

        x = new LgvModuleItem();
        x.id = 'tokenView';
        x.label = 'Token View';
        x.link = 'token';
        x.roles = [''];
        x.childPages = [];
        this.TokenModule = x;

        this.Modules = [
            this.DefaultModule,
            this.ClientModule,
            this.AgentModule,
            this.AdminModule,
            this.TokenModule
        ];

        this.MasterPageList = [
            {
                link: 'overview',
                label: 'Overview',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Agent',
                    'Assistant',
                    'PreLicensedAgent'
                ],
                icon: 'line-chart',
                iconStyle: 'solid'
            },
            {
                link: 'loan-pipeline',
                label: 'Loan Pipeline',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Agent',
                    'Processor',
                    'Assistant',
                    'PreLicensedAgent'
                ],
                icon: 'landmark-magnifying-glass',
                iconStyle: 'regular'
            },
            {
                link: 'admin-clients',
                label: 'Clients',
                roles: ['Admin', 'CompanyAdmin'],
                icon: 'address-card',
                iconStyle: 'solid'
            },
            {
                link: 'licensing',
                label: 'Licensing',
                roles: ['Admin', 'PreLicensedAgent'],
                icon: 'list-check',
                iconStyle: 'regular',
                isPreLicensed: true
            },
            {
                link: 'admin-activities',
                label: 'Activities',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Agent',
                    'Assistant',
                    'CompanyAdminAgent'
                ],
                icon: 'question-circle',
                iconStyle: 'regular',
                hidden: true
            },
            {
                link: 'agent-clients',
                label: 'Clients',
                roles: ['Agent', 'CompanyAdminAgent', 'PreLicensedAgent'],
                icon: 'address-card',
                iconStyle: 'solid'
            },
            {
                link: 'agents',
                label: 'Agents',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'CompanyAdminAgent',
                    'ConciergeKey'
                ],
                icon: 'user-group',
                iconStyle: 'regular'
            },
            {
                link: 'admin-profile',
                label: 'Profile',
                roles: [],
                hidden: true
            },
            {
                link: 'auth-info',
                label: 'Auth Info',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Developer',
                    'CompanyAdminAgent'
                ],
                hidden: true
            },
            {
                link: 'service-tester',
                label: 'Service Tester',
                roles: ['Admin', 'CompanyAdmin', 'Developer'],
                hidden: true
            },
            {
                label: 'Client Details',
                link: 'client-details',
                roles: [],
                hidden: true
            },
            {
                link: 'companies',
                label: 'Companies',
                roles: ['Admin'],
                icon: 'sitemap',
                iconStyle: 'regular'
            },
            {
                link: 'organization',
                label: 'Organizations',
                roles: ['Admin'],
                icon: 'building',
                iconStyle: 'solid'
            },
            {
                link: 'pricing-scenario',
                label: 'Pricing',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Agent',
                    'Assistant',
                    'PreLicensedAgent',
                    'Processor'
                ],
                icon: 'circle-dollar',
                iconStyle: 'solid'
            },
            {
                link: 'view-email',
                label: 'Emails',
                roles: [
                    'Admin',
                    'CompanyAdmin',
                    'Agent',
                    'Processor',
                    'Assistant'
                ],
                icon: 'envelope',
                iconStyle: 'solid',
                hidden: true
            }
            //{ link: 'agent-co-branding-clients', label: 'Co-Branding Clients', roles: ['Agent', 'CompanyAdminAgent'] }
        ];
    }

    NavPagesForRoles(userRoles: string[]): LgvNavItem[] {
        return this.FilterPagesForRoles(this.MasterPageList, userRoles);
    }

    FilterPagesForRoles(
        pages: LgvNavItem[],
        userRoles: string[]
    ): LgvNavItem[] {
        let rtnVal: LgvNavItem[] = [];

        for (let x of pages) {
            if (x.hidden) {
                continue;
            }

            if (x.roles.length === 0) {
                rtnVal.push(x);
            } else {
                for (let reqRole of x.roles) {
                    //console.log(`${x.link} | reqRole => ${reqRole}`);
                    if (userRoles.indexOf(reqRole) !== -1) {
                        if (
                            x.link == 'loan-pipeline' &&
                            !this.isLoanPipelineApplicable(x)
                        ) {
                            break;
                        } else {
                            rtnVal.push(x);
                            break;
                        }
                    }
                }
            }
        }

        return rtnVal;
    }

    isLoanPipelineApplicable(x: LgvNavItem) {
        return (
            this.companyService.loanApplications$?.value?.name ===
                'LendingPad' ||
            this.companyService.loanApplications$?.value?.name ===
                'MeridianLink' ||
            this.userService.IsAdmin ||
            this.userService.IsDLR ||
            this.userService.isPreLicensedAgent ||
            this.userService.IsCK ||
            this.userService.IsProcessor
        );
    }

    ModFromLink(link: string): LgvModuleItem {
        if (!link) {
            return null;
        }
        if (link === '/') {
            return this.DefaultModule;
        }

        link = LgvModuleService.StripUrlBeforeHash(link);

        let urlParts = link.split('/');
        if (urlParts.length > 1) {
            let modLink = urlParts[1];

            let newMod = this.Modules.find(x => x.link == modLink);
            if (newMod) {
                //console.log('FOUND: ' + newMod.link);
                return newMod;
            }
        }
        console.log('*** MOD NOT FOUND *** ModFromLink: ' + link);
        return null;
    }

    static StripUrlBeforeHash(url: string): string {
        let hashIndex = url.indexOf('#');
        return hashIndex != -1 ? url.substring(hashIndex + 1) : url;
    }
}
